import moment from "moment";

export const getDelimiter = (content) => {
  const delimiters = [",", "\t", ";", "|"];
  const lines = content.split("\n");
  const firstLine = lines[0];
  let limiter;
  const delimiterCounts = delimiters.map((delimiter) => ({
    delimiter,
    count: firstLine.split(delimiter).length - 1,
  }));

  const likelyDelimiter = delimiterCounts.reduce((a, b) =>
    a.count > b.count ? a : b
  ).delimiter;
  switch (likelyDelimiter) {
    case ",":
      limiter = "comma";
      break;
    case "\t":
      limiter = "tab";
      break;
    case ";":
      limiter = "semicolon";
      break;
    case "|":
      limiter = "pipe";
      break;
    default:
      break;
  }
  return limiter;
};

export const getFirstRow = (content, delimiter) => {
  const lines = content.split("\n");
  const firstLine = lines[0];
  return firstLine
    .split(changeDelimiter(delimiter))
    .map((item) => item.trim().replace(/^"(.*)"$/, "$1"));
};

export const checkFirstRowForEmptyColumn = (content, delimiter) => {
  const lines = content.split("\n");
  const firstLine = lines[0];
  const columns = firstLine.split(changeDelimiter(delimiter)); // assuming comma as delimiter
  const hasEmptyColumn = columns.some((column) => column.trim() === "");
  return hasEmptyColumn;
};

const changeDelimiter = (delimiter) => {
  let limiter;
  switch (delimiter) {
    case "comma":
      limiter = ",";
      break;
    case "tab":
      limiter = "\t";
      break;
    case "semicolon":
      limiter = ";";
      break;
    case "pipe":
      limiter = "|";
      break;
    default:
      break;
  }
  return limiter;
};

const checkIfNumeric = (value) => {
  return !isNaN(value) && !isNaN(parseFloat(value));
};

const checkIfDate = (value) => {
  const date = new Date(value);
  return !isNaN(date.getTime());
};

const checkIfDateMoment = (value) => {
  const dateFormats = [
    "YYYY/MM/DD",
    "DD/MM/YYYY",
    "DD-MM-YYYY",
    "YYYY-MM-DD",
    "DD-MMM-YYYY",
    "YY/MM/DD",
    "DD/MM/YY",
    "DD-MM-YY",
    "YY-MM-DD",
    "DD-MMM-YY",
  ];
  for (let format of dateFormats) {
    if (moment(value, format, true).isValid()) {
      return true;
    }
  }
  return false;
};

export const checkNumeric = (content, delimiter) => {
  let separator = changeDelimiter(delimiter);
  let row = content.split("\n")[0];
  const values = row.split(separator);
  for (let i = 0; i < values.length; i++) {
    const trimmedValue = values[i].trim();
    if (checkIfNumeric(trimmedValue)) {
      return true;
    }
  }
  return false;
};

export const checkDate = (content, delimiter) => {
  let separator = changeDelimiter(delimiter);
  let row = content.split("\n")[0];

  const values = row.split(separator);
  for (let i = 0; i < values.length; i++) {
    const trimmedValue = values[i].trim();
    if (checkIfDateMoment(trimmedValue)) {
      return true;
    }
  }
  return false;
};
